export default {

    LOADER_USERS(state, item) {
        state.selectUsers = item
    },



}